import React from "react";
import {
    UserOutlined,
    CheckCircleOutlined,
    MailOutlined,
    CloseCircleOutlined,
    SaveOutlined,
} from "@ant-design/icons";
import StatsCard from "../../../components/StatsCard";
import { Button, Col, Flex, Row, Space, Typography } from "antd";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Box from "../../../components/Box/Box";
import FormSetup from "../../../components/Forms/FormSetup";
import { MasterConfigs } from "../../../interfaces/entity";
import moment from "moment";
const { Text } = Typography;
const data = [
    {
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];


const OrganizationSummary = () => {
    const [employeeForm, setEmployeeForm] = React.useState(false);

    const stats = [
        {
            label: "Total Head Count",
            value: 32,
            icon: <UserOutlined />,
            color: "#FFA500",
            extraInfo: "+4 / -0",
        },
        {
            label: "Registered",
            value: 31,
            icon: <CheckCircleOutlined />,
            color: "#6A5ACD",
        },
        {
            label: "Not Invited",
            value: 0,
            icon: <MailOutlined />,
            color: "#32CD32",
        },
        {
            label: "Yet to Register",
            value: 0,
            icon: <CloseCircleOutlined />,
            color: "#FF6347",
        },
    ];

    const PendingStats = [
        {
            label: "Doccuments",
            value: 32,
            icon: <SaveOutlined />,
            color: "#FFA500",
        },
        {
            label: "Expenses",
            value: 31,
            icon: <CheckCircleOutlined />,
            color: "#6A5ACD",
        },
        {
            label: "Probations",
            value: 0,
            icon: <MailOutlined />,
            color: "#32CD32",
        },
        {
            label: "Join Tasks",
            value: 0,
            icon: <CloseCircleOutlined />,
            color: "#FF6347",
        },
        {
            label: "Exit Tasks",
            value: 0,
            icon: <CloseCircleOutlined />,
            color: "#FF6347",
        },
        {
            label: "Profile Changes",
            value: 0,
            icon: <CloseCircleOutlined />,
            color: "#FF6347",
        },
    ];

    const disabledPastDate = (current) => {
        return current && current < moment().subtract(10, 'days').startOf('day');
    }

    const disabledDate = (current) => {
        const getLast10Year = moment().subtract(10, 'years');
        return current && current > moment(getLast10Year).endOf('day');
    }

    const config: MasterConfigs = {
        api: () => '/users',
        isSteps: true,
        restrictDirectJump: true,
        getFormColumns: () => [
            {
                api: () => '/users',
                tabName: 'Basic Details',
                getChiledForm: () => {
                    return [
                        {
                            label: 'First Name',
                            name: 'firstName',
                            type: 'text',
                            rules: [{
                                required: true,
                                message: 'First Name is required'
                            }]
                        },
                        {
                            label: 'Middel Name',
                            name: 'middelName',
                            type: 'text',
                            isRequired: false,
                        },
                        {
                            label: 'Last Name',
                            name: 'lastName',
                            type: 'text',
                            rules: [{
                                required: true,
                                message: 'Last Name is required'
                            }]
                        },
                        {
                            label: 'Gender',
                            name: 'gender',
                            rules: [{
                                required: true,
                                message: 'Gender is required'
                            }],
                            type: 'select',
                            children: [
                                { name: 'Male', value: 'Male' },
                                { name: 'Female', value: 'Female' },
                                { name: 'Other', value: 'Other' },
                            ],
                        },
                        {
                            label: 'Date Of Birth',
                            name: 'dob',
                            rules: [{
                                required: true,
                                message: 'Date Of Birth is required'
                            }],
                            dateProps: {
                                disabledDate: disabledDate,
                                format: 'DD MMM YYYY',
                            },
                            type: 'date',
                        },
                        {
                            span: 8
                        },
                        {
                            label: 'Work Email',
                            name: 'workEmail',
                            type: 'text',
                            rules: [{
                                required: true,
                                message: 'Work Email is required'
                            }, {
                                type: 'email',
                                message: 'Invalid email address'
                            }],
                        },
                        {
                            label: 'Email',
                            name: 'email',
                            type: 'text',
                            rules: [{
                                required: true,
                                message: 'Email is required'
                            }, {
                                type: 'email',
                                message: 'Invalid email address'
                            }],
                        },
                        {
                            span: 8
                        },
                        {
                            label: 'Mobile',
                            name: 'mobile',
                            type: 'number',
                            rules: [{
                                required: true,
                                message: 'Mobile is required'
                            }, {
                                pattern: /^[0-9]{10}$/,
                                message: "Mobile number must be 10 digits long!",
                            }],
                        },
                        {
                            label: 'Work Type',
                            name: 'workType',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Work Type is required'
                            }],
                            isCombo: true,
                        },
                        {
                            span: 8
                        },
                        {
                            label: 'Number Serise',
                            name: 'numberSeries',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Number Serise is required'
                            }],
                            isCombo: true,
                        },
                        // {
                        //     label: 'Employee Id',
                        //     name: 'employeeId',
                        //     type: 'text',
                        //     inputProps: { disabled: true },
                        // },
                    ];
                }
            },
            {
                api: () => '/users',
                tabName: 'Basic Details',
                getChiledForm: () => {
                    return [
                        {
                            label: 'Date Of Joining',
                            name: 'dateOfJoining',
                            rules: [{
                                required: true,
                                message: 'Date Of Joining is required'
                            }],
                            type: 'date',
                            dateProps: {
                                disabledDate: disabledPastDate
                            }
                        },
                        {
                            label: 'Designation',
                            name: 'role',
                            rules: [{
                                required: true,
                                message: 'Designation is required'
                            }],
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Job Title',
                            name: 'jobTitles',
                            rules: [{
                                required: true,
                                message: 'Job Title is required'
                            }],
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Time Type',
                            name: 'timeType',
                            type: 'select',
                            isCombo: true,
                            rules: [{
                                required: true,
                                message: 'Time type is required'
                            }],
                        },
                        {
                            label: 'Reporting Manager',
                            name: 'reportingManager',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Reporting Manager is required'
                            }],
                            isCombo: true,
                        },
                        { span: 8 },
                        {
                            label: 'Legal Entity',
                            name: 'legalEntity',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Legal entity is required'
                            }],
                            isCombo: true,
                        },
                        {
                            label: 'Business Unit',
                            name: 'businessUnit',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Business unit is required'
                            }],
                            isCombo: true,
                        },
                        {
                            label: 'Department',
                            name: 'department',
                            type: 'select',
                            isCombo: true,
                            rules: [{
                                required: true,
                                message: 'Department is required'
                            }],
                        },
                        {
                            label: 'Location',
                            name: 'location',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Location is required'
                            }],
                            isCombo: true,
                        },
                        {
                            type: 'custom',
                            span: 24,
                            label: 'Advance',
                            render: () => <Text style={{ color: '#1677ff' }} strong>Advance</Text>,
                        },
                        {
                            label: 'Probation Policy',
                            name: 'probationPolicy',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Probation is required'
                            }],
                            isCombo: true,
                        },
                        {
                            label: 'Notice Period',
                            name: 'noticePeriod',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Notice period is required'
                            }],
                            isCombo: true,
                        },
                    ];
                }
            },
            {
                api: () => '/users',
                tabName: 'Work Details',
                getChiledForm: () => {
                    return [
                        {
                            label: 'Invite Employee to login',
                            name: 'inviteEmployeetoLogin',
                            type: 'checkbox',
                        },
                        // {
                        //     label: 'Enable onboarding flow',
                        //     name: 'enableOnboardingFlow',
                        //     type: 'checkbox',
                        // },
                        // {
                        //     label: 'Select Onboarding Flow',
                        //     name: 'onboardingFlow',
                        //     type: 'select',
                        //     selectProps: { placeholder: 'Select Onboarding Flow' },
                        //     children: [
                        //         { name: 'Basic Details', value: 'Basic Details' },
                        //         { name: 'Work Type', value: 'Work Type' },
                        //         { name: 'Salary', value: 'Salary' },
                        //         { name: 'Doccuments', value: 'Doccuments' },
                        //     ],
                        // },
                        {
                            type: 'custom',
                            span: 24,
                            render: () => <Text strong>Time & Attandance Settings</Text>
                        },
                        {
                            label: 'Leave Plans',
                            name: 'leavePlans',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Shift Type',
                            name: 'shiftType',
                            type: 'select',
                            children: [],
                            rules: [{ required: true, message: 'Field is required' }],
                            isCombo: true,
                        },
                        {
                            label: 'Weekly Off',
                            name: 'weeklyOff',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Attendance Number',
                            name: 'attendanceNumber',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Holiday List',
                            name: 'holidayList',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            type: 'custom',
                            span: 24,
                            render: () => <Text strong>Attendance Tracking Settings</Text>
                        },
                        {
                            label: 'Attandance Capture Scheme',
                            name: 'attandanceCaptureScheme',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Attandance Tracking Policy',
                            name: 'attandanceTrackingPolicy',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Overtime Policy',
                            name: 'overtimePolicy',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            type: 'custom',
                            span: 24,
                            render: () => <Text strong>Other Settings</Text>
                        },
                        {
                            label: 'Expense Policy',
                            name: 'expensePolicy',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        }
                    ];

                }
            },
            {
                api: () => '/users',
                tabName: 'Compansation',
                getChiledForm: () => {
                    return [
                        {
                            label: 'Enable payroll for this employee',
                            name: 'enablePayroll',
                            type: 'checkbox',
                            span: 24,
                        },
                        {
                            label: 'Pay Group',
                            name: 'payGroup',
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Anual Salary',
                            name: 'anualSalary',
                            type: 'number',
                            isCombo: true,
                        },
                        {
                            span: 24,
                            type: 'custom',
                            render: () => <Text strong>Payroll Settings</Text>
                        },
                        {
                            label: 'Provident Fund (PF) Eligible',
                            name: 'pfEligible',
                            type: 'checkbox',
                            span: 24,
                        },
                        {
                            label: 'Salary Structure Type',
                            name: 'salaryStructureType',
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Custom Salary Structure',
                            name: 'customSalaryStructure',
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Tax regime to consider',
                            name: 'taxRegime',
                            type: 'select',
                            isCombo: true,
                        }
                    ];
                }
            }
        ],
        combo: [
            {
                api: '/employee-number',
                name: 'numberSeries',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                api: '/worker-type',
                name: 'workType',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                name: 'role',
                api: '/role',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'department',
                api: '/departments',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'reportingManager',
                api: '/users/?includingme=yes',
                idKey: '_id',
                render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
            },
            {
                name: 'timeType',
                api: '/time-type',
                idKey: '_id',
                render: (e) => e.name
            }, {
                name: 'legalEntity',
                api: '/legal-entity',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'businessUnit',
                api: '/business-unit',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'location',
                api: '/locations',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'probationPolicy',
                api: '/probation-policies',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'noticePeriod',
                api: '/notice-period',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'jobTitles',
                api: '/job-titles',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'leavePlans',
                api: '/leave-plan',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'shiftType',
                api: '/shift-time',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'weeklyOff',
                api: '/weekly-offs',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attendanceNumber',
                api: '/attendance-number',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'holidayList',
                api: '/holiday-list',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attandanceCaptureScheme',
                api: '/attendance-capture-scheme',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attandanceTrackingPolicy',
                api: '/attendance-tracking-policy',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'overtimePolicy',
                api: '/overtime',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'expensePolicy',
                api: '/expences-policy',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                name: 'payGroup',
                api: '/pay-group',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'salaryStructureType',
                api: '/salary-structure-type',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'customSalaryStructure',
                api: '/custom-salary-structure-type',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'taxRegime',
                api: '/tax-regime',
                idKey: '_id',
                render: (ele) => ele.name,
            }
        ],
    }

    return (
        <Row gutter={[16, 16]}>
            <Col span={8}>
                <StatsCard title="Employees" stats={stats} />
            </Col>
            <Col flex={"auto"}>
                <StatsCard title="Pending Actions" span={8} stats={PendingStats} />
            </Col>
            <Col span={8}>
                <Box title={false}>
                    <Button onClick={() => setEmployeeForm(true)}>Add Employee</Button>
                    {/* <EmployeeForm isOpen={employeeForm} onClose={() => { setEmployeeForm(false) }} /> */}
                    <FormSetup config={config} open={employeeForm} onClose={() => { setEmployeeForm(false) }} />
                </Box>
            </Col>
            <Col span={16}>
                <Box title="Employee login summary">
                    <div style={{ height: 300 }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart
                                width={500}
                                height={400}
                                data={data}
                                margin={{
                                    top: 10,
                                    right: 30,
                                    left: 0,
                                    bottom: 0,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip />
                                <Area type="monotone" dataKey="uv" stroke="#8884d8" fill="#8884d8" />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                </Box>
            </Col>
            <Col span={6}>
                <Box title="Onboarding"></Box>
            </Col>
            <Col span={6}>
                <Box title="Probation"></Box>
            </Col>
            <Col span={6}>
                <Box title="Birthdays"></Box>
            </Col>
            <Col span={6}>
                <Box title="Work Anniversaries"></Box>
            </Col>
        </Row>
    );
}

export default OrganizationSummary;